
import { createElement } from "react";
import React from "react";
import { TableContainer } from "../../Widgets/Container.js";
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { StorageQrCodeTable } from "../../Widgets/Tables/QrCodeTable.js";
import { Msg } from "./Types.js";
import { empty, toArray, ofArray, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Permission, Permissions_has, StorageAccess } from "../../Shared/Roles.js";
import { useTranslation } from "react-i18next";
import { Table } from "../../Widgets/Table/Table.js";
import { ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import { Role__ToI18nString } from "../../Shared/Shared.js";
import { map as map_1, defaultArg, unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { usePermissions } from "../../UserPermissions.js";
import { empty as empty_1, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { ConfirmationDialog } from "../../Components/Dialog.js";
import { DetailViewHeader } from "../../Widgets/DetailViewHeader.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { LabeledValue } from "../../Components/Text.js";
import { Feature, isFeatureEnabled } from "../../FeatureFlip.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, initViewStorageView } from "./State.js";
import { Skeleton } from "../../Components/Skeleton.js";

function QRCodeSection(props) {
    let elems;
    return createElement(TableContainer, {
        Content: reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems = [createElement(StorageQrCodeTable, {
            OnAssignQrCode: (arg) => {
                props.Dispatch(new Msg(3, [arg]));
            },
            OnDeleteQrCodes: (arg_1) => {
                props.Dispatch(new Msg(4, [arg_1]));
            },
            QrCodes: props.Storage.QRCodeIds,
            Storage: new StorageAccess(props.Storage.Id, map((_arg) => _arg.UserId, props.Storage.AssignedUsers)),
            UserData: props.UserData,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])]))),
        Title: props.Header,
    });
}

function UserListSection(props) {
    let Title, elems, TableRows;
    const t = useTranslation()[0];
    return createElement(TableContainer, (Title = t(props.HeaderTranslationKey), {
        Content: reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems = [createElement(Table, (TableRows = toArray(props.Users), {
            ColumnDefinitions: [new ColumnDefinition$1("name", "", t("general.name"), (dto) => (new CellContent(0, [dto.Name])), "none", "text"), new ColumnDefinition$1("id", "", t("general.role"), (dto_1) => (new CellContent(0, [t(Role__ToI18nString(dto_1.Role))])), "none", "text"), new ColumnDefinition$1("department", "", t("user.department"), (dto_2) => (new CellContent(0, [dto_2.Department])), "none", "text")],
            Controls: empty(),
            Options: {
                BorderStyle: "row",
                CSVDownload: false,
                ConfigurableColumns: false,
                CustomTableFilters: false,
                DefaultSortColumn: ["name", "asc"],
                Fullscreen: false,
                GlobalSearch: false,
                RowSelection: "disabled",
                SaveTableConfiguration: false,
            },
            TableKey: "not-defined-table",
            TableRows: TableRows,
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))),
        Title: unwrap(Title),
    }));
}

export function StorageDetails(props) {
    let elems_5;
    const t = useTranslation()[0];
    const permissions = usePermissions();
    return reactElement("div", createObj(ofArray([["className", join(" ", ["max-w-[75rem]"])], (elems_5 = toList(delay(() => {
        let Title;
        return append(singleton(createElement(ConfirmationDialog, (Title = t("general.delete"), {
            Description: t("storage.storage_delete_msg"),
            FormState: props.FormState,
            IsOpen: props.IsDeleteDialogOpen,
            OnClose: () => {
                props.Dispatch(new Msg(1, []));
            },
            OnConfirm: () => {
                props.Dispatch(new Msg(2, []));
            },
            Title: Title,
        }))), delay(() => {
            let Title_1;
            return append(singleton(createElement(DetailViewHeader, (Title_1 = t("storage.storage_details"), {
                Badges: empty(),
                OnBack: () => {
                    RouterModule_nav(ofArray(["storages"]), 1, 1);
                },
                OnDelete: unwrap(Permissions_has(permissions, new Permission(68, [])) ? (() => {
                    props.Dispatch(new Msg(0, []));
                }) : undefined),
                OnEdit: unwrap(Permissions_has(permissions, new Permission(67, [])) ? (() => {
                    RouterModule_nav(ofArray(["storages", props.Storage.Id, "edit"]), 1, 1);
                }) : undefined),
                Title: Title_1,
            }))), delay(() => {
                let elems_1, elems;
                return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-shrink-0", "flex-col", "mb-3", "bg-white", "rounded", "px-12", "py-9"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["grow", "mx-4", "mt-3"])], (elems = toList(delay(() => append(singleton(LabeledValue({
                    Label: t("general.name"),
                    Value: props.Storage.Name,
                })), delay(() => append(singleton(LabeledValue({
                    Label: t("general.description"),
                    Value: props.Storage.Description,
                })), delay(() => append(isFeatureEnabled(new Feature(17, [])) ? singleton(LabeledValue({
                    Label: t("business_units.business_unit"),
                    Value: defaultArg(props.Storage.BusinessUnitName, ""),
                })) : empty_1(), delay(() => append(singleton(LabeledValue({
                    Label: t("general.location"),
                    Value: defaultArg(map_1((location) => location.Name, props.Storage.Location), "–"),
                })), delay(() => ((props.Storage.SelfServiceConfiguration.IsStorageSelfService ? true : props.Storage.SelfServiceConfiguration.IsGlobalSelfService) ? singleton(LabeledValue({
                    Label: t("storage.self_service_user"),
                    Value: t("storage.is_self_service_active"),
                })) : empty_1()))))))))))), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                    let elems_2;
                    return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["pt-5"])], (elems_2 = [createElement(UserListSection, {
                        HeaderTranslationKey: "storage.stockists",
                        Users: props.Storage.AssignedUsers,
                    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                        let elems_3;
                        return append((!props.Storage.SelfServiceConfiguration.IsStorageSelfService && !props.Storage.SelfServiceConfiguration.IsGlobalSelfService) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["pt-5"])], (elems_3 = [createElement(UserListSection, {
                            HeaderTranslationKey: "storage.self_service_user",
                            Users: props.Storage.AccessByUsers,
                        })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))) : empty_1(), delay(() => {
                            let elems_4;
                            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["pt-5"])], (elems_4 = [createElement(QRCodeSection, {
                                Dispatch: props.Dispatch,
                                Header: "general.qr_codes",
                                Storage: props.Storage,
                                UserData: props.UserData,
                            })], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
                        }));
                    }));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

export function StorageDetailsView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(initViewStorageView, update_1, (_arg, _arg_1) => {
    }), props.StorageId, undefined);
    const state_1 = patternInput[0];
    const matchValue = state_1.Storage;
    if (matchValue.tag === 0) {
        return createElement(Skeleton, {
            Variant: "detail",
        });
    }
    else {
        return createElement(StorageDetails, {
            Dispatch: patternInput[1],
            FormState: state_1.FormState,
            IsDeleteDialogOpen: state_1.IsDeleteDialogOpen,
            Storage: matchValue.fields[0],
            UserData: props.UserData,
        });
    }
}

